import { AdvancedEstimateSections } from './estimateSectionTypes';

export interface Invoice {
  fullName: string;
  address: string;
  title: string;
  message: string;
  amount: number;
  servicesDone?: string[];
  invoiceLink?: string;
  status: string;
  askFor?: string;
  lineItems?: any;
  clientId: string;
  id: string;
  isEstimate: boolean;
  depositLink?: string;
  depositAmount?: number;
  dateCreated?: any;
  dateModified?: any;
  meshColor?: string;
  frameColor?: string;
  email?: string;
  phoneNumber?: string;
  // Estimate specific fields
  customerName?: string;
  customerId?: string;
  userId?: string;
  totalPrice?: number;
  total?: number; // TODO: Move everything over from amount and total price to start using this instead
  dimensions?: any[];
  solarScreens?: any[];
  meshType?: number;
  costPerSquareFoot?: number;
  notes?: string;
  selectedServices?: any;
  // Payment plan fields
  paymentPlan?: "months_12" | "months_6" | "months_3" | "half_now" | "full_payment" | "none";
  discountedTotal?: number;
  discountPercent?: number;
  discount?: number; // TODO: Move everything over to discount from discountPercent
  // New unified discount fields
  discountType?: 'percentage' | 'fixed' | null;
  discountValue?: number;
  discountAmount?: number;
  // Totals
  subtotal?: number;
  tax?: number;
  taxRate?: number;
  // Invoice related fields
  invoiceIds?: string[];
  firstInvoiceId?: string;
  parentEstimateId?: string;
  paymentNumber?: number;
  totalPayments?: number;
  dueDate?: any;
  paymentDate?: any;
  // Development flag
  dev?: boolean;
  pricingType?: "dimensions" | "custom";
  // Images
  images?: string[];
  // Tip fields
  tipAmount?: number;
  tipPercent?: number | null;
  tipType?: 'percentage' | 'fixed' | null;
  // Advanced estimate sections
  advancedSections?: AdvancedEstimateSections;
  // Payment status fields
  lastPaymentStatus?: 'failed' | 'succeeded' | string;
  lastPaymentError?: string;
  lastPaymentAttempt?: any;
  // E-signature fields
  signatureLocked?: boolean;
  companyId?: string;
  signature?: {
    signerFullName: string;
    signatureImagePath: string;
    signedAtUTC: string;
    ipAddress: string;
    userAgent: string;
    documentHash: string;
    consentGiven: boolean;
    consentText: string;
    signedPDFPath: string;
    inputType?: 'draw' | 'type';
  };
}

export const AskForConstants = {
  referral: "referral",
  review: "review"
};

export const InvoiceStatus = {
  paid: "paid",
  open: "open",
  pending: "pending",
  scheduled: "scheduled",
  processing: "processing"
};

export const EstimateStatus = {
  accepted: "accepted",
  open: "open",
  signed: "signed"
};

export type PayingClient = {
  firstName: string;
  lastName?: string;
  address: string;
  phoneNumber?: string;
  email?: string;
  zipCode: string;
  // Firebase saves date objects as a FirebaseTimestamp which Typescript is unaware of, so we need to handle the date as object type any
  dateOfService: any;
  costOfService: number;
  servicesProvided: string[];
  lineItems?: any[];
  notes?: string;
  id: string;
  howCustomerFoundUs?: string;
};
